import LoadingWrapper from './LoadingWrapper';
import {connect, selectors} from '../../../stores';

const mapStateToProps = state => ({
  globalLoading: selectors.auth.selectGlobalLoading(state)
});

const ConnectedLoadingWrapper =  connect(
  mapStateToProps, null
)(LoadingWrapper);

export default ConnectedLoadingWrapper;
